import api from "./api";
export const fetchMemberReporting = async (params) => {
  try {
    const response = await api.get("api/reports/member", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching member reporting data:", error);
    throw error;
  }
};

export const exportMemberReporting = async (params) => {
  try {
    const response = await api.get("/api/reports/member/export", {
      params,
      responseType: "blob",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting member reporting data:", error);
    throw error;
  }
};

export const fetchSupervisorReporting = async (params) => {
  try {
    const response = await api.get("api/reports/supervisor", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching supervisor reporting data:", error);
    throw error;
  }
};

export const exportSupervisorReporting = async (params) => {
  try {
    const response = await api.get("/api/reports/supervisor/export", {
      params,
      responseType: "blob",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting supervisor reporting data:", error);
    throw error;
  }
};

export const fetchInvoicingReporting = async (params) => {
  try {
    const response = await api.get("api/reports/invoice", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching invoice reporting data", error);
    throw error;
  }
};

export const exportInvoicingReporting = async (params) => {
  try {
    const response = await api.get("/api/reports/invoice/export", {
      params,
      responseType: "blob",
      headers: {
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting supervisor reporting data", error);
    throw error;
  }
};
